<template>
  <div class="personalResBox">
    <div class="content">
      <div class="innerTitle">
        <el-button type="primary" size="small" @click="add">新增</el-button>
        <div class="screenBox">
          <el-cascader
            v-model="cascaderArr"
            :options="options"
            :props="props"
            size="small"
            style="width: 47%"
            clearable
            @change="handleChange">
          </el-cascader>
          <el-select v-model="searchForm.status" size="small" style="width: 47%" placeholder="请选择状态" @change="selectChange" clearable>
            <el-option label="未签" :value="0" />
            <el-option label="已签" :value="1" />
          </el-select>
        </div>
      </div>
      <div class="tableBox">
        <el-table
        :data="tableData"
        border
        :header-cell-style="{ background: 'rgb(232,232,232)', height: '55px', textAlign: 'center' }"
        :row-style="{ height: '55px' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%">
        <el-table-column
          type="index"
          :index='(index) => {return index + 1 + (curPage-1)*limit}'
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          prop="resTitle"
          label="个人责任书">
          <template slot-scope="{ row }">
            <el-link type="primary" :underline="false" @click="jumpJobResponse(row.responsibleJobId)">{{ row.resTitle }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="resDepName"
          label="部门">
        </el-table-column>
        <el-table-column
          prop="resJobName"
          label="岗位">
          </el-table-column>
        <el-table-column
          prop="yeas"
          label="年度">
        </el-table-column>
        <el-table-column
          prop="resEmpName"
          label="员工">
        </el-table-column>
        <el-table-column
          prop="proName"
          label="制定人">
        </el-table-column>
        <el-table-column
          prop="proTime"
          width="100"
          label="制定日期">
          <template slot-scope="{ row }">
            {{ row.proTime | filter1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="checkTime"
          width="110"
          label="预定考核时间">
          <template slot-scope="{ row }">
            {{ row.checkTime | filter1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="checkEmpName"
          width="110"
          label="考核人">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
          <template slot-scope="{ row }">
            <span v-if="row.status === 0" style="color: #E6A23C">未签</span>
            <span v-else style="color: #409EFF">已签</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="{ row }">
            <el-link type="primary" style="margin-right: 10px" @click="edit(row)" v-if="row.status === 0">编辑</el-link>
            <el-link type="warning" style="margin-right: 10px" @click="detail(row.id)">详情</el-link>
            <el-link type="primary" style="margin-right: 10px" @click="sign(row)" v-if="row.status === 0">签字</el-link>
            <el-link type="primary" style="margin-right: 10px" @click="examine(row)">考核</el-link>
            <el-link type="danger" @click="deleteList(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 15px; text-align: right">
        <Page :total='total' :page-size='limit' :current='curPage' @on-change='curPageChange' />
      </div>
      </div>
    </div>
    <!-- 签字的弹窗 -->
    <el-dialog
      title="签字"
      :visible.sync="signVisible"
      width="25%"
      :before-close="signClose">
      <div>请上传签字文件</div>
      <el-upload
        class="avatar-uploader"
        action="/v1/trainMaterials/uploadFile"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        accept=".jpg,.png,.gif,.jpeg"
        :before-upload="beforeAvatarUpload">
        <img v-if="imageUrl" :src="host + imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signClose" size="small">取 消</el-button>
        <el-button type="primary" @click="signSure" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 考核的弹窗 -->
    <el-dialog
      title="考核"
      :visible.sync="examineVisible"
      width="25%"
      :before-close="examineClose">
      <el-form :model="diaForm" :rules="rules" label-width="110px" size="small" ref="diaForm">
        <el-form-item label="评分" prop="assessScore">
          <el-input v-model="diaForm.assessScore" placeholder="请输入评分" />
        </el-form-item>
        <el-form-item label="考核内容" prop="assessContent">
          <el-input v-model="diaForm.assessContent" placeholder="请输入考核内容" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="下次考核时间" prop="nextCheckTime">
          <el-date-picker
            v-model="diaForm.nextCheckTime"
            type="datetime"
            style="width: 100%"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="examineClose" size="small">取 消</el-button>
        <el-button type="primary" @click="examineSure" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getResponsePersonalList, responsibleEmpDelete, getAllDepartment, signPersonalResPonse, examinePersonResponse } from '@/api/processManager'
export default {
  name: 'mainTarget',
  data() {
    return {
      searchForm: {
        resJobId: '',
        resDepId: '',
        status: ''
      },
      typeList: [
        { id: 0, name: '年度目标' },
        { id: 1, name: '季度目标' },
        { id: 2, name: '月度目标' },
      ],
      levelList: [
        { id: 1, name: '公司级' },
        { id: 2, name: '部门级' },
      ],
      tableData: [],
      limit: 10,
      total: 0,
      curPage: 1,
      // 级联选择器
      options: [],
      props: {
        label: 'name',
        children: 'jobVos',
        value: 'id'
      },
      cascaderArr: [],
      // 签字的弹窗
      signVisible: false,
      imageUrl: '',
      // 当前条目的id
      id: '',
      // 考核的弹窗
      examineVisible: false,
      diaForm: {},
      rules: {
        assessScore: [{ required: true, message: '请输入评分' }],
        assessContent: [{ required: true, message: '请输入考核内容' }],
        nextCheckTime: [{ required: true, message: '请选择下次考核时间' }]
      }
    }
  },
  // 过滤器
  filters: {
    filter1(time) {
      return time.split(' ')[0]
    }
  },
  created() {
    this.getData()
    this.getAllDepartment()
  },
  methods: {
    // 获取数据
    getData() {
      getResponsePersonalList({ limit: this.limit, curPage: this.curPage, ...this.searchForm }).then(res => {
        this.tableData = res.body.data;
        this.total = res.body.cum
      })
    },
    // 获取所有部门和下面的岗位
    getAllDepartment() {
      getAllDepartment().then(res => {
        this.options = res.body.data
      })
    },
    // 级联选择器的事件
    handleChange(value) {
      // console.log(value);
      // return
      if(value.length !== 0) {
        this.searchForm.resJobId = value[1],
        this.searchForm.resDepId = value[0]
      }
      else {
        this.searchForm.resJobId = ''
        this.searchForm.resDepId = ''
      }
      this.getData()
    },
    // 下拉框选择的事件
    selectChange() {
      this.getData();
    },
    // 翻页
    curPageChange(val) {
      this.curPage = val;
      this.getData();
    },
    // 新增按钮
    add() {
      this.$router.push({
        path: 'personalAdd'
      })
    },
    // 编辑
    edit(row) {
      this.$router.push({
        name: 'personalAdd',
        params: { ...row }
      })
    },
    // 删除
    deleteList(row) {
      this.$confirm(`删除 ${row.resTitle }, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        responsibleEmpDelete(row.id).then(res => {
          this.$message.success('删除成功');
          this.getData();
        })
      }).catch(() => {
        return      
      });
    },
    // 详情/审核
    detail(id) {
      this.$router.push(`personalDetail/${id}`)
    },
    // 跳转到岗位责任书详情
    jumpJobResponse(id) {
      this.$router.push({
        path: `positionDetail/${id}`,
      })
    },
    // 签字
    sign(row) {
      this.signVisible = true
      this.id = row.id
    },
    // 关闭签字
    signClose() {
      this.signVisible = false
    },
    // 签字弹窗确定按钮
    signSure() {
      let obj = { id: this.id, signFileUrl: this.imageUrl }
      signPersonalResPonse({ id: this.id, signFileUrl: this.imageUrl }).then(res => {
        this.$message.success('操作成功')
        this.signClose()
        this.getData()
      })
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data;
    },
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或者 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    // 考核
    examine(row) {
      this.examineVisible = true
      this.id = row.id
    },
    examineClose() {
      this.examineVisible = false
      this.$refs['diaForm'].resetFields();
    },
    examineSure() {
      examinePersonResponse({ ...this.diaForm, responsibilityId: this.id }).then(res => {
        this.$message.success('考核成功！')
        this.examineClose()
      })
    }
  }
}
</script>

<style scoped>
.innerTitle {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}
.innerTitle .screenBox {
  width: 30%;
  display: flex;
  justify-content: space-between;
}
.personalResBox /deep/ .el-dialog__body{
  padding: 10px 20px;
}
.personalResBox /deep/ .avatar-uploader {
  /* text-align: center */
}
</style>